import { useEffect } from 'react';
import { renewTokenQuietly } from '../api';

// Keeps the Microsoft sign-in fresh for someone who is working: every ten minutes, if there has been any movement in the last
// half hour, the access token is renewed when it is close to the end (so an hour of work never runs into a stale token), and again
// when the page comes back into view. Someone who has left the page alone is not kept signed in.
const EVERY_MS = 10 * 60 * 1000;
const ACTIVE_WITHIN_MS = 30 * 60 * 1000;

export default function useSessionKeepAlive(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    let lastMove = Date.now();
    const touch = () => { lastMove = Date.now(); };
    const events = ['mousedown', 'keydown', 'touchstart', 'wheel', 'scroll'];
    events.forEach((e) => window.addEventListener(e, touch, { passive: true, capture: true }));
    const mouse = () => { lastMove = Date.now(); };
    window.addEventListener('mousemove', mouse, { passive: true });
    const tick = () => { if (Date.now() - lastMove < ACTIVE_WITHIN_MS) renewTokenQuietly(); };
    const timer = setInterval(tick, EVERY_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') tick(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(timer);
      events.forEach((e) => window.removeEventListener(e, touch, { capture: true }));
      window.removeEventListener('mousemove', mouse);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [enabled]);
}
